import Promise from 'bluebird';
import { omit } from 'underscore';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';
import {
  TargetingSettingsContext,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

export function fetchPreferenceConfig(gridName) {
  const {
    state, segmentPreference, fetchPaginationConfig, segmentTimeChecker,
  } = TargetingSettingsContext;
  const {
    getSegPreference, getSegType,
  } = segmentPreference;

  return new Promise((resolve) => {
    getGridPreferences({ // bluebird promise
      gridName, // should be the same as the grid config
      dateUtil: {
        format: value => TargetingSettingsContext.i18n.formatDate(value),
      },
      state,
      getSegPreference,
      getSegType,
      segmentTimeChecker,
      fetchPaginationConfig,
    }).then((preferenceConfig) => {
      // eslint-disable-next-line no-param-reassign
      preferenceConfig.dataSource = omit(preferenceConfig.dataSource, 'query');
      resolve(preferenceConfig);
    });
  });
}
